module.exports = __webpack_public_path__ + "3c0888dab2fc61d94dc35e6ab0cefff1.svg";